/**
 * Configuration for marketplace feature restrictions
 *
 * How to use:
 * To restrict a feature to specific marketplaces, you would:
 *
 * 1. Define the marketplace IDs in this file:
 * export const MARKETPLACE_IDS_FOR_FEATURE: Record<string, number[]> = {
 *   Staging: [33, 4],     // Only specific marketplaces in staging
 *   Development: [0],     // All marketplaces in development
 *   Production: []        // No marketplaces in production
 * };
 *
 * 2. Create a helper function:
 * export const featureMarketplaceIds = () => {
 *   const environment = process.env.REACT_APP_ENVIRONMENT ?? 'Production';
 *   return MARKETPLACE_IDS_FOR_FEATURE[environment] || [];
 * };
 *
 * 3. Use in components/routes:
 * // In Routes.tsx
 * const featureEnabled = featureMarketplaceIds().includes(0) ||
 *   featureMarketplaceIds().includes(marketplace.id || 0);
 *
 * // In components
 * const MenuItem = {
 *   ...
 *   exclusiveMarketplaceIds: featureMarketplaceIds()
 * };
 */

// Example marketplace IDs for reference:
// [33] - BluesClues
// [4]  - HealthySmiles | House Calls
// [1]  - HealthySmiles Pet Dental | Plantation
// [5284] - HealthySmiles | Boca
// [82] - HealthySmiles | Cypress TX
// [99] - HealthySmiles | Miami
// [79] - HealthySmiles Pet Dental (Field)
// [53] - HealthySmiles | Fort Lauderdale

// This configuration is kept as an example but is not currently in use
export const MARKETPLACE_IDS_FOR_MEMBERSHIP: Record<string, number[]> = {
    Staging: [0],
    Development: [0],
    Production: [0]
};

// This function is kept as an example but is not currently in use
export const membershipMarketplaceIds = () => {
    const environment = process.env.REACT_APP_ENVIRONMENT ?? 'Production';
    return MARKETPLACE_IDS_FOR_MEMBERSHIP[environment] || [];
};
